import Header from "../components/studio/Header";
import Sidebar from "../components/studio/Sidebar";

import '../components/studio/styles.scss';
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  return (
    <div className="app-container">
      <Header />
      <div className="main-content">
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
}
